<div class="flex flex-wrap">
  <div class="w-full">
    <nav
      class="relative flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-gray-800"
    >
      <div
        class="container px-4 mx-auto flex flex-wrap items-center justify-between"
      >
        <div
          class="w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start"
        >
          <a
            class="text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-no-wrap uppercase text-white"
            routerLink="/"
          >
            Remitfree
          </a>
          <button
            class="text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
            type="button"
            (click)="toggleMenu()"
          >
            <fa-icon [icon]="faBars"></fa-icon>
          </button>
        </div>
        <div
          [ngClass]="{ hidden: !mobileMenu, flex: mobileMenu }"
          class="lg:flex lg:flex-grow items-center"
        >
          <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
            <li class="nav-item">
              <a
                class="flex ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-900 transition duration-150 ease-in-out"
                routerLink="/"
              >
                Home
              </a>
            </li>
            <li class="nav-item">
              <a
                class="flex ml-4 px-3 py-2 rounded-md text-sm font-medium leading-5 text-gray-300 hover:text-white hover:bg-gray-900 focus:outline-none focus:text-white focus:bg-gray-900 transition duration-150 ease-in-out"
                routerLink="/about"
              >
                About
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>
